const inactiveBrowserTabLock = () =>
  new Promise<void>(resolve => {
    if (!document.hidden) {
      resolve()
      return
    }
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        resolve()
      }
    })
  })

export const helpersBrowser = {
  inactiveBrowserTabLock,
}
